/* wishlist.js — client-side wishlist (localStorage, no account needed).
   Stores only non-sensitive display fields {id,url,title,img,price}. Renders with DOM
   nodes (textContent) — never innerHTML — per the theme's security rule. Hearts + drawer
   are delegated on document so they survive card re-renders. */
(function () {
  const KEY = 'tne_wishlist_v1';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const set = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch {} };
  const has = (id) => get().some((i) => i.id === id);

  function toggle(data) {
    const list = get(); const i = list.findIndex((x) => x.id === data.id);
    if (i >= 0) list.splice(i, 1); else list.push(data);
    set(list); paint(); renderDrawer();
    return i < 0;
  }
  function remove(id) { set(get().filter((x) => x.id !== id)); paint(); renderDrawer(); }

  function paint() {
    $$('[data-wish]').forEach((b) => b.setAttribute('aria-pressed', String(has(b.getAttribute('data-wish-id')))));
    const n = get().length;
    $$('[data-wish-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  }

  function el(tag, cls, txt) { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  function renderDrawer() {
    const box = $('[data-wish-items]'); if (!box) return;
    const list = get(); box.textContent = '';
    if (!list.length) {
      const s = el('div', 'state'); s.appendChild(el('div', 'state__icon', '🤍'));
      s.appendChild(el('p', null, (window.WISH_I18N && window.WISH_I18N.empty) || 'Your wishlist is empty.'));
      box.appendChild(s); return;
    }
    list.forEach((it) => {
      const row = el('div', 'wish-line');
      const a = el('a', 'wish-line__media'); a.href = it.url;
      if (it.img) { const im = el('img'); im.src = it.img; im.alt = ''; im.width = 60; im.height = 60; im.loading = 'lazy'; a.appendChild(im); }
      const info = el('div', 'wish-line__info');
      const t = el('a', 'wish-line__title', it.title); t.href = it.url;
      info.appendChild(t); if (it.price) info.appendChild(el('div', 'wish-line__price', it.price));
      const rm = el('button', 'wish-line__remove'); rm.type = 'button';
      rm.setAttribute('aria-label', (window.WISH_I18N && window.WISH_I18N.remove) || 'Remove'); rm.textContent = '✕';
      rm.addEventListener('click', () => remove(it.id));
      row.append(a, info, rm); box.appendChild(row);
    });
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    const on = toggle({
      id: b.getAttribute('data-wish-id'), url: b.getAttribute('data-wish-url'),
      title: b.getAttribute('data-wish-title'), img: b.getAttribute('data-wish-img'),
      price: b.getAttribute('data-wish-price')
    });
    b.setAttribute('aria-pressed', String(on));
  });

  document.addEventListener('DOMContentLoaded', () => { paint(); renderDrawer(); });
  document.addEventListener('shopify:section:load', () => { paint(); renderDrawer(); });
  paint(); renderDrawer();
})();
